import { useNavigate } from 'react-router-dom'
import { InfoIcon } from '~/@mid_ui/icons/InfoIcon'
import { Text } from '~/@mid_ui/typography/Text'
import { NoInvestmentsSvg } from './NoInvestmentsSvg'
import { Button } from '~/shadcn/ui/button/button'

function NoInvestments() {
  const navigate = useNavigate()
  return (
    <div className="flex flex-row items-end justify-center gap-10 mt-20">
      <NoInvestmentsSvg />
      <div className="border border-[#121212] p-3 pr-5 pl-3 bg-[#EBF4FF] flex flex-row gap-2 rounded-lg max-w-[317px]">
        <InfoIcon className="mt-2 w-4 h-4 min-w-4 min-h-4" />
        <div className="flex flex-col gap-2">
          <Text>Zatiaľ nemáte žiadne investície</Text>
          <div className="flex flex-col gap-4">
            <Text>
              V otvorených príležitostiach na vás čakajú nové zaujímavé možnosti
              investovania. Každý si môže vybrať na základe vlastných
              preferencií. Nepremeškajte túto možnosť!
            </Text>
            <Button variant="outline" onClick={() => navigate('/projects')}>
              Otvorené príležitosti
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export { NoInvestments }
